import React from "react"
import {
  Box, Text, VStack,
} from "@chakra-ui/react"
import { SubscriptionType } from "sharedTypes"
import UpgradeAlert from "components/elements/UpgradeAlert"
import ContainedForm from "components/ReactHookForm/ContainedForm"
import RadioButtons, { RadioOptionLabel } from "components/ReactHookForm/RadioButtons"
import SettingsSection from "components/settings/SettingsSection"
import { Boolean } from "utilities/enums"
import { TEMPORAL_QR_CODES_ARTICLE_LINK } from "utilities/externalLinks"
import Link from "components/elements/Link"

type Props = {
  expiringQRCodes: boolean
  temporalQRCodesEnabled: boolean
  qrCodesEnabled: boolean
  updateEvent: (params: {}) => Promise<void>
}

type FormValues = {
  expiringQrCodes: Boolean // lowercase 'r' expected by backend
}

const QRCodeSecurity = ({
  expiringQRCodes, temporalQRCodesEnabled, qrCodesEnabled, updateEvent,
}: Props) => {
  const onSubmit = (values: FormValues) => updateEvent(values)

  return (
    <SettingsSection title="QR Code Security">
      <ContainedForm
        values={{
          expiringQrCodes:
            expiringQRCodes ? Boolean.True : Boolean.False,
        }}
        onSubmit={onSubmit}
        name="QR Code Security"
      >
        {({ control }) => (
          <Box pt={4}>
            <QRCodeSecurityFormFields
              control={control}
              temporalQRCodesEnabled={temporalQRCodesEnabled}
              qrCodesEnabled={qrCodesEnabled}
            />
          </Box>
        )}
      </ContainedForm>
    </SettingsSection>
  )
}

export const QRCodeSecurityFormFields = ({ control, qrCodesEnabled, temporalQRCodesEnabled }) => (
  <RadioButtons
    name="expiringQrCodes"
    control={control}
    spacing={6}
    options={[
      {
        label: (
          <RadioOptionLabel
            disabled={!qrCodesEnabled}
            title="Standard QR Codes"
            description={(
              <Text>
                Guests receive standard QR codes after successful registration or ticket payment.
                These codes streamline the check-in process.
              </Text>
            )}
          />
        ),
        value: Boolean.False,
        disabled: !qrCodesEnabled,
      },
      {
        label: (
          <VStack>
            <RadioOptionLabel
              disabled={!temporalQRCodesEnabled}
              title="Temporal QR Codes"
              description={(
                <>
                  <Text>
                    Temporal QR codes are Diobox’s proprietary, time-based codes that prevent guests
                    from using screenshots or sharing QR codes.
                    Each code can only be used once, ensuring secure verification.
                  </Text>
                  <Text>
                    To learn more, see: <Link target="_blank" href={TEMPORAL_QR_CODES_ARTICLE_LINK}>Temporal QR Codes</Link>.
                  </Text>
                </>
              )}
            />
            {!temporalQRCodesEnabled && (
              <UpgradeAlert text="This feature requires an Enterprise Subscription." defaultSelectedPlan={SubscriptionType.Enterprise} />
            )}
          </VStack>
        ),
        value: Boolean.True,
        disabled: !temporalQRCodesEnabled,
      },
    ]}
  />
)

export default QRCodeSecurity
